import { render, staticRenderFns } from "./return.vue?vue&type=template&id=4155bce5&scoped=true"
import script from "./return.vue?vue&type=script&lang=js"
export * from "./return.vue?vue&type=script&lang=js"
import style0 from "./return.vue?vue&type=style&index=0&id=4155bce5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155bce5",
  null
  
)

export default component.exports